import classNames from 'classnames'
import { useCurrentUser } from '../../../../../modules/context/UserContext'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { LOCALE_KO } from '../../../../../modules/i18n/config'
import { s_home } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { STUDENT_BTN_ID } from '../../../../../modules/ids/gtm/student'
import urls from '../../../../../modules/urls'
import {
  IMG_HOME_DESKTOP_PRICING_1,
  IMG_HOME_DESKTOP_PRICING_2,
  IMG_HOME_DESKTOP_PRICING_3,
  IMG_HOME_SECTION_ICON_PRICING,
} from '../../../constants/home.constants'
import { sendHomeSectionClickEvent } from '../../../helpers/HomeHelpers'

type PricingSectionProps = {
  bgColor: string
}

const PricingSection: React.FC<PricingSectionProps> = ({ bgColor }) => {
  const { currentUser } = useCurrentUser()
  const { t, locale } = useTranslation()

  const router = useAppRouter()

  const handleClickSeeMore = () => {
    sendHomeSectionClickEvent(
      STUDENT_BTN_ID.CLICK_SECTION_PRICING,
      '가격 더 알아보기',
      currentUser,
      router,
      undefined,
      null
    )
    router.push(urls.student.landing.pricing)
  }

  return (
    <div
      style={{ backgroundColor: bgColor }}
      className="flex flex-col items-center justify-center pt-[114px] pb-[100px]"
    >
      <div className="flex max-w-[1080px] flex-col items-center justify-center px-[20px]">
        <div className="flex items-center justify-center">
          <img src={IMG_HOME_SECTION_ICON_PRICING} alt="review-section-icon" className="h-[32px] w-[32px]" />
          <p
            className={
              (classNames('ml-4 whitespace-pre-line text-[#7C7F94]'),
              locale === LOCALE_KO ? 'Headline2-24Bd' : 'Headline3-22Bd')
            }
          >
            {t(s_home.pricing_title.subtitle.desktop)}
          </p>
        </div>

        <div className="mt-16 text-center">
          <h2
            className={classNames(
              'whitespace-pre-line text-[#000000]',
              locale === LOCALE_KO ? 'Hero3-36Bd' : 'Hero4-32Bd'
            )}
          >
            {t(s_home.pricing_title.title.desktop)}
          </h2>

          <div
            className={classNames(
              'mt-8 flex justify-center whitespace-pre-line text-[#AFB1C0]',
              locale === LOCALE_KO ? 'Body1-16Md' : 'Body2-14Md'
            )}
          >
            <span>{t(s_home.pricing_title.caption.desktop)}</span>
          </div>

          <p
            className={classNames(
              'mt-16 whitespace-pre-line text-[#585D71]',
              locale === LOCALE_KO ? 'Title1-20Md' : 'Title2-18Md'
            )}
          >
            {t(s_home.pricing_title.bodytxt.desktop)}
          </p>
        </div>

        <div className="mt-[48px] flex w-full items-center justify-between px-[88px]">
          <div>
            <img
              src={IMG_HOME_DESKTOP_PRICING_1(locale)}
              alt="pricing-card-left"
              className="h-full w-full flex-1"
              loading="lazy"
            />
          </div>
          <div>
            <img
              src={IMG_HOME_DESKTOP_PRICING_2(locale)}
              alt="pricing-card-mid"
              className="h-full w-full flex-1"
              loading="lazy"
            />
          </div>
          <div>
            <img
              src={IMG_HOME_DESKTOP_PRICING_3(locale)}
              alt="pricing-card-right"
              className="h-full w-full flex-1"
              loading="lazy"
            />
          </div>
        </div>

        <div className="mt-[52px] flex w-full items-center justify-end pl-[88px] pr-[104px]">
          <button
            className={classNames(
              'flex items-center justify-center text-purple-500',
              locale === LOCALE_KO ? 'Body1-16Bd' : 'Body2-14Bd'
            )}
            onClick={() => handleClickSeeMore()}
          >
            <span>{t(s_home.pricing_title.cta.desktop)}</span>
            <i className="fe fe-lg fe-chevron-right text-18 ml-2" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default PricingSection
